import { Box, Img, Text, VStack, Image, useDisclosure, Button } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import BottomNavBar from 'components/BottomNavBar';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import Contact from '../../../../../images/ClinicoIcon.svg';
import { Form, Formik } from 'formik';
import Loading from 'components/Loading';
import TelemedDeslogado from '../../../../../../src/images/Deslogado/telemedDeslogado.svg';
import SelectEspecialistas from 'components/SelectEspecialistas';
import useModelEspecialista from './ModelEspecialista';

function Main() {
  const { user } = useContext(AccountContext);
  const { state } = useLocation();
  const { patient, nascimento, idClientClinica } = state;
  const navigate = useNavigate();
  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const [especialidadeEscolha, setEscolha] = useState(null);
  const defaultArgs = { borderRadius: 8, w: '100%', maskChar: null };
  const disclosure = useDisclosure();
  const defaultArgsSelect = { textAlign: 'left', fontWeight: 'normal', variant: 'outline', onChange: () => {} };
  const sexoPaciente = state.sexo !== 'M' && state.sexo !== 'm';

  useEffect(() => {
    setEscolha(especialidadeEscolha);
  }, [especialidadeEscolha]);

  const { especialidades, loading, idade, notificacao } = useModelEspecialista(sexoPaciente, especialidadeEscolha, patient, null, nascimento);
  const tipos_plano = [55, 29];

  return !loading ? (
    <>
      <VStack
        align="center"
        justify={{
          base: 'center',
          md: 'space-around',
          xl: 'space-between',
        }}
        direction={{ base: 'column-reverse' }}
        wrap="no-wrap"
        minH="100vh"
        spacing={0}
        background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
        color="#585858"
      >
        <Image
          top="calc(env(safe-area-inset-top, 0px) + 1em)"
          left="1.3em"
          zIndex="9999"
          position="absolute"
          boxSize={{ base: '32px', sm: '40px' }}
          src={BackButton}
          onClick={() => navigate(-1)}
        />
        <Box
          mt="1"
          id=""
          as="card"
          width="100%"
          minHeight="100%"
          borderRadius="18px"
          fontSize="xs"
          size="10"
          backgroundColor="white"
          maxInlineSize="80"
          textAlign="center"
          p={'4'}
        >
          <VStack mt="5%">{!loading ? <Image src={usuarioAssinante ? Contact : TelemedDeslogado} height={'4.5em'} /> : <></>}</VStack>

          <Text fontWeight="bold" fontSize="1.5em" color={'#585858'}>
            Especialidades Disponíveis
          </Text>

          <Formik initialValues={{ especialidade: null }} validateOnChange={false} validateOnBlur={false}>
            <VStack as={Form} w="100%">
              <Text color={'#757575'} fontSize={'16px'}>
                Selecione a especialidade abaixo
              </Text>
              <VStack m="2em" w="100%">
                <SelectEspecialistas
                  {...defaultArgs}
                  {...defaultArgsSelect}
                  name="especialidade"
                  placeholder="Selecione"
                  options={especialidades}
                  cliente_id={state?.client_id}
                  cpf={state?.patient}
                  h={'3em'}
                  backgroundColor={'#EEEEEE'}
                  color={'#9E9E9E'}
                  onChange={(e) => {
                    if (especialidades[e]?.agendas_disponiveis > 0) {
                      setEscolha(especialidades[e].ambulatorio_tipo_consulta_id);
                    } else {
                      setEscolha(null);
                    }
                    //listarAtendimentos();
                    //fetchSessoes(especialidades[e].ambulatorio_tipo_consulta_id);
                  }}
                  idade={idade}
                  notificacao={notificacao}
                />
              </VStack>
              {tipos_plano.includes(user?.id_plano) && (
                <>
                  <Text color={'gray.400'} fontWeight={'semibold'} textAlign={'left'}>
                    A especialidade escolhida só estará disponível na data prevista
                  </Text>
                </>
              )}
              <Button
                textAlign="center"
                id="callBtn"
                w="100%"
                background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
                textColor="white"
                fontWeight="bold"
                fontSize="1.5em"
                mt="2em"
                disabled={especialidadeEscolha ? false : true}
                onClick={() => {
                  navigate('/medico-agora/especialista/lista', {
                    state: {
                      segunda_consulta: state.segunda_consulta,
                      pacienteEscolhido: patient,
                      nascimento: nascimento,
                      typeList: 'Especialista',
                      especialidade: especialidadeEscolha,
                      especialidade_id: especialidadeEscolha,
                      idClientClinica,
                      sexo: state.sexo,
                    },
                  });
                }}
              >
                Continuar
                {/*<chakra.span>
                    <ArrowForwardIcon fontSize="0.9em" />
                  </chakra.span>*/}
              </Button>
            </VStack>
          </Formik>
        </Box>
      </VStack>
      <BottomNavBar />
    </>
  ) : (
    <VStack
      align="center"
      justify={{
        base: 'center',
        md: 'space-around',
        xl: 'space-between',
      }}
      direction={{ base: 'column-reverse' }}
      wrap="no-wrap"
      minH="100vh"
      spacing={0}
      background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
      color="#585858"
    >
      <Image
        top="calc(env(safe-area-inset-top, 0px) + 1em)"
        left="1.3em"
        zIndex="9999"
        position="absolute"
        boxSize={{ base: '32px', sm: '40px' }}
        src={BackButton}
        onClick={() => navigate(-1)}
      />
      <Box
        mt="1"
        id=""
        as="card"
        width={{ base: '92%', sm: '328px' }}
        maxW="328px"
        minHeight="340"
        borderRadius="18px"
        fontSize="xs"
        size="10"
        backgroundColor="white"
        maxInlineSize="80"
        textAlign="center"
      >
        <VStack mt="2em">
          <Image src={usuarioAssinante ? BackButton : TelemedDeslogado} alt="teste" height={'4.5em'} />
          <Loading />
        </VStack>
      </Box>
    </VStack>
  );
}

export default Main;
